import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as propertySelectors from "@rentiohq/shared-frontend/dist/reduxV2/property/property.selectors";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { appendQueryParams } from "@rentiohq/shared-frontend/dist/utils/url.utils";
import {
  Button,
  DisplayText,
  ESpacings,
  Grid,
} from "@rentiohq/web-shared/dist/components";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { IRootStore } from "redux/reducers";
import { Tasks } from "../../../../scenes/Tasks/Tasks";

export const TasksForProperty = () => {
  const navigate = useNavigate();

  const params = useParams<{ propertyId: string }>();
  const propertyId = params.propertyId ? +params.propertyId : undefined;

  const property = useSelector((state: IRootStore) =>
    propertyId ? propertySelectors.getDetail(state, propertyId) : undefined,
  );
  const { isBroker } = authHooks.useSelf();

  if (!property) return null;

  const handleAddTaskClick = (_: any, isKeypoint?: boolean) => {
    if (!propertyId) {
      return;
    }

    navigate(
      appendQueryParams({
        path: "/tasks/add",
        queryParams: {
          propertyId,
          keypoint: isKeypoint ? 1 : 0,
        },
      }),
    );
  };
  return (
    <>
      <Grid
        mb={ESpacings.base}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid.Item>
          <DisplayText size="medium">
            {getLocalizedText("properties.tasks")}
          </DisplayText>
        </Grid.Item>

        <Grid.Item>
          <div style={{ display: "flex" }}>
            {isBroker && (
              <>
                <Button
                  appearance="outline"
                  color="blue"
                  size="small"
                  onClick={event => handleAddTaskClick(event, true)}
                >
                  {getLocalizedText("task.repair.service.keypoint")}
                </Button>
                <div style={{ width: ESpacings.loose }} />
              </>
            )}
            <Button
              appearance="primary"
              size="small"
              onClick={handleAddTaskClick}
            >
              {getLocalizedText("tasks.new")}
            </Button>
          </div>
        </Grid.Item>
      </Grid>
      <Tasks propertyId={property.id} asPage={false} showCounts={false} />
    </>
  );
};
